import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import DropInPayments from '../../components/DropInPayments/DropInPayments';
import { Provider } from 'react-redux';
import { storeBuilder } from '../../utils/ReduxStoreUtil';
import { executeDropInPaymentsCommands } from '../../redux/command/command.action';
import { isArrayEmptyOrNull } from '../../utils/ObjectUtils';
import { initializeRioClient, Namespace, Environment, fireStatusUpdate, setCallback, SharedCommandNames, Component, StatusTypes, checkoutClient } from '@chegg/commerce-utils';
import { initClient } from '@chegg/rio2-web-client';
import { assignEnv } from '../../components/DropInPayments/helper';
import { forterSnippet, getForterSnippetSiteId } from './helper';
var DropInPayment = function DropInPayment(props) {
  var config = props.config,
    review = props.review,
    callback = props.callback,
    commands = props.commands,
    optimizelyClient = props.optimizelyClient,
    taxInfo = props.taxInfo;
  var environment = config.environment,
    authorization = config.authorization,
    useForter = config.useForter;
  var cheggBaseUrl = authorization.cheggBaseUrl;
  setCallback(callback, Namespace.DROP_IN_PAYMENTS);
  var store = storeBuilder().getStore({
    config: config,
    review: review,
    optimizelyClient: optimizelyClient,
    taxInfo: taxInfo
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    authorized = _useState2[0],
    setAuthorized = _useState2[1];
  useEffect(function () {
    if (!isArrayEmptyOrNull(commands)) {
      store.dispatch(executeDropInPaymentsCommands(commands));
    }
    initializeSDK();
  }, [commands]);
  useEffect(function () {
    initClient();
    initializeSDK();
    if (environment === Environment.DEVELOPMENT) {
      initializeRioClient({
        appId: 'WT',
        authState: 'hard_logged_in',
        property: 'study',
        view: {
          property: 'chegg',
          experience: 'bundle',
          view_name: 'viewName'
        },
        endpoint: 'their_endpoint'
      }, props.config.rioNamespace);
    }
    if (useForter || useForter === undefined) {
      var script = document.createElement('script');
      var env = assignEnv(cheggBaseUrl);
      var id = getForterSnippetSiteId(env);
      script.innerHTML = forterSnippet(env);
      script.setAttribute('id', id);
      script.async = true;
      document.body.appendChild(script);
    }
    return function () {
      storeBuilder().resetStore();
    };
  }, []);
  var initializeSDK = function initializeSDK() {
    if (!authorized) {
      var response = checkoutClient.authorize(authorization);
      if (!isArrayEmptyOrNull(response.errors)) {
        fireStatusUpdate([{
          status: StatusTypes.ERROR,
          command: SharedCommandNames.AUTHORIZE,
          payload: {
            component: Component.APP,
            errors: response.errors
          }
        }], Namespace.DROP_IN_PAYMENTS);
      }
      setAuthorized(isArrayEmptyOrNull(response.errors));
    }
  };
  var renderDropInPayments = function renderDropInPayments(config) {
    return /*#__PURE__*/React.createElement(Provider, {
      store: store
    }, /*#__PURE__*/React.createElement(DropInPayments, {
      config: config,
      optimizelyClient: optimizelyClient
    }));
  };
  return authorized ? renderDropInPayments(config) : null;
};
export default DropInPayment;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/external/DropInPayments/index.js
// module id = 4363
// module chunks = 11